import React, { Component } from "react";
import { Navigate } from "react-router-dom";

class ErrorBoundary extends Component {
  state = { hasError: false, redirect: false };

  static getDerivedStateFromError(error) {
    return { hasError: true, redirect: true };
  }

  componentDidCatch(error, errorInfo) {
    // console.error("Render Hatası Yakalandı:", error, errorInfo);
  }

  componentDidUpdate() {
    if (this.state.redirect) {
      // Yönlendirme tamamlandıktan sonra state'i sıfırla
      this.setState({ hasError: false, redirect: false });
    }
  }

  render() {
    if (this.state.redirect) {
      return <Navigate to="/server-error" replace />;
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
